import { Link } from 'react-router-dom'
import { Footer, SECTIONS } from '../components/layout/Footer.jsx'
import { APP_NAME, APP_TAGLINE } from '../utils/constants.js'

// Standalone Privacy Policy page. The source of truth for the content
// is SECTIONS.privacy in Footer.jsx so the in-app Footer modal and this
// routed page never drift. UX31 added these pages because Google OAuth
// app verification requires a public, stable URL for the Privacy Policy
// (a modal with no URL doesn't satisfy the review).
export function PrivacyPage() {
  return (
    <div className="app-shell">
      <header className="header">
        <div className="header-inner">
          <div className="brand">
            <Link to="/" className="brand-text" style={{ color: 'inherit', textDecoration: 'none' }}>
              <span className="brand-name">{APP_NAME}</span>
              <span className="brand-tagline">{APP_TAGLINE}</span>
            </Link>
          </div>
        </div>
      </header>

      <main className="legal-page">
        <h1>{SECTIONS.privacy.title}</h1>
        <div className="legal-page-body">
          {SECTIONS.privacy.body}
        </div>
        <p className="legal-page-back">
          <Link to="/">← Back to {APP_NAME}</Link>
        </p>
      </main>

      <Footer />
    </div>
  )
}
